import { IDataSet } from '../Track';

export enum TransactionType {
    REWARD = 'REWARD',
    COIN_PURCHASE = 'COIN_PURCHASE',
    PURCHASE = 'PURCHASE',
    AD = 'AD',
    INVENTORY = 'INVENTORY',
}

export enum TGameArea {
    MAP = 'MAP',
    SOCIAL_SCREEN = 'SOCIAL_SCREEN',
    EVENT_SCREEN = 'EVENT_SCREEN',
    LEVEL = 'LEVEL',
}

export enum TActionType {
    WHEEL_SPIN = 'WHEEL_SPIN',
    BOOSTER_USE = 'BOOSTER_USE',
    INVENTORY_PURCHASE = 'INVENTORY_PURCHASE',
    WEEKLY_EVENT = 'WEEKLY_EVENT',
    GATE = 'GATE',
    AD = 'AD',
    SOCIAL = 'SOCIAL',
    BOT = 'BOT',
    REWARD = 'REWARD',
    DAILY_MISSION = 'DAILY_MISSION',
}

export interface IProductsSpentReceived {
    items: Object[];
    realCurrency: IRealCurrency;
    virtualCurrencies: Object[];
}

export interface IRealCurrency {
    realCurrencyType: string;
    realCurrencyAmount: number;
}

export enum VirtualCurrencyTypes {
    GRIND = 'GRIND',
    PREMIUM = 'PREMIUM',
    PREMIUM_GRIND = 'PREMIUM_GRIND',
}

export class TransactionDataSet implements IDataSet {
    public tChangerReceived: number = 0;
    public tChangerUsed: number = 0;
    public tRemoveOneReceived: number = 0;
    public tRemoveOneUsed: number = 0;
    public tMassRemoveReceived: number = 0;
    public tMassRemoveUsed: number = 0;
    public tJokerReceived: number = 0;
    public tJokerUsed: number = 0;
    public tCoinsReceived: number = 0;
    public tCoinsUsed: number = 0;
    public tLivesReceived: number = 0;
    public tMapExtraCardsReceived: number = 0;
    public tLevelExtraCardsReceived: number = 0;
    public tLevelExtraCardsNumber: number = 0;
    public tUndoUsed: number = 0;
    public transactionType: TransactionType = undefined;
    public tGameArea: TGameArea = undefined;
    public tActionType: TActionType = undefined;
    public tLevelTypeContext: string = undefined;
    public tLevelContext: number = undefined;
    public transactionID: string = '';
    public productsSpent: Object = undefined;
    // special resource events
    public tShopRewardCoins: number = 0;
    public tCoinsLevelEnd: number = 0;
    public tAdCoins: number = 0;
    public tIAPCoins: number = 0;
    public tFailFlowCoinsReceived: number = 0;
    public tFailFlowCoinsUsed: number = 0;
    public tStreakExtraCards: number = 0;
    public tHelperCards: number = 0;
    // special transaction events
    public tTransactionCoins: number = 0;
    public tTransactionBoosters: number = 0;
    public tTransactionCoinWorth: number = 0;
}
